import React from 'react';
import './Button.css';

export interface ButtonProps {
  variant?: 'primary' | 'secondary';
  children: React.ReactNode;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  children,
  onClick,
  type = 'button',
}) => {
  return (
    <button
      className={`button button--${variant}`}
      onClick={onClick}
      type={type}
    >
      {children}
    </button>
  );
}; 